export default class Bike {

    constructor(id, type, height, folder, colors, wheel, color = 'blackblue') {

        this.id = id;
        this.type = type;
        this.height = height;
        this.folder = folder;
        this.colors = colors;
        this.wheel = wheel;
        this.color = color;

    }

};


// WEBPACK FOOTER //
// ./src/classes/Bike.js